import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import AngularFilterHelperService from '../services/angular-filter-helper.service';
import AngularMaterialHelperService from '../services/angular-material-helper.service';

@Injectable({ providedIn: 'root' })
export default class Toast {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularMaterialHelperService: AngularMaterialHelperService = inject(AngularMaterialHelperService);
	private snackBar: MatSnackBar = this.angularMaterialHelperService.getMaterialToast();

	private toastMessageQueue: Array<{ message: string; parentElement: HTMLElement | null }> = [];
	private toastActive = false;
	private maxQueueSize = 2;

	showWithTranslation(translationKey: string) {
		this.showWithTranslationInParent(translationKey, null);
	}

	showWithTranslationInParent(translationKey: string, parentElement: HTMLElement | null) {
		const message = this.angularFilterHelperService.translate(translationKey);
		this.enqueueToast(message, parentElement);
	}

	show(message: string) {
		this.showInParent(message, null);
	}

	showInParent(message: string, parentElement?: HTMLElement | null) {
		this.enqueueToast(message, parentElement);
	}

	showAsync(message: string, action = 'X', delay = 5000, theme?: string) {
		if (!message) return;

		this.snackBar.open(message, action, {
			duration: delay,
			horizontalPosition: 'left',
			verticalPosition: 'bottom',
			panelClass: theme ? [theme] : undefined,
		});
	}

	private enqueueToast(message: string, parentElement?: HTMLElement | null) {
		if (this.toastActive) {
			if (this.toastMessageQueue.length < this.maxQueueSize) {
				this.toastMessageQueue.push({ message, parentElement });
			}
		} else {
			this.displayToast(message, parentElement);
		}
	}

	private displayToast(message: string, parentElement: HTMLElement | null) {
		this.toastActive = true;

		const snackBarRef: MatSnackBarRef<any> = this.snackBar.open(message, 'X', {
			duration: 2000,
			horizontalPosition: 'left',
			verticalPosition: 'bottom',
			// parentElement is not directly supported by MatSnackBar
		});

		snackBarRef.afterDismissed().subscribe(() => {
			this.toastActive = false;
			if (this.toastMessageQueue.length > 0) {
				const next = this.toastMessageQueue.shift();
				if (next) {
					this.displayToast(next.message, next.parentElement);
				}
			}
		});
	}
}
